<template>
    <div class="container gradient_box">
        <div class="header">
            <img src="../../assets/images/moli/logo.png" style="margin-top: 1rem;" alt="Molly Tea Logo" class="logo">
            <h1 class="title">Win a Jasmine Tea Latte</h1>
            <p class="subtitle">Select premium ingredients to craft your perfect Jasmine Tea Latte!</p>
        </div>
        <div class="middle received">
            <div class="cup"></div>
            <div class="main">
                <div class="reward-card">
                    <h2 class="congrats-text" style="font-size: 0.9rem;">🎉 Thanks for your support! Our mini-game has been so popular that we’ve hit the player limit!</h2>
                    <h2 class="congrats-text" style="font-size: 0.9rem;">But don’t worry—a new giveaway is live! Click below to try your luck! 🎊👇</h2>

                    <button class="login-button" style="font-size: 1rem;" @click="doClose">Enter Giveaway</button>
                </div>
                <div class="minipass">Powered by minipass</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

    export default {
        name: 'MoliGameOver',
        data() {
            return {
            };
        },
        beforeUpdate() {},
        updated() {},
        beforeCreate() {},
        created() {
        },
        watch: {
        },
        computed: {
            ...mapGetters({
                msg: 'app/get_app_msg'
            }),
            ...mapState({
            }),
        },
        methods: {
            ...mapActions({
                initData: 'app/initData',
            }),
            ...mapMutations({
            }),
            doClose() {
                window.open('https://reserve.minitable.net/draw/120 ');
            }
        }
    };
</script>

<style scoped>
    @import '../../assets/style/moli/base.css';
    @import '../../assets/style/moli/index.css';

    .received .cup {
        background-image: url(../../assets/images/moli/over.png);
        background-size: auto 100%;
        background-position: center right;
    }
    .congrats-text {
        color: #999;
    }
</style>